export function setTitle(title: string): void {
    window.document.title = title
}
